// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .mat-list-item-content {
  padding: 0 !important;
}

.button-blue {
  border-radius: 1.5rem;
}

mat-sidenav-container {
  z-index: 10;
}
mat-sidenav-container > * {
  background: var(--background);
  width: 50%;
}

.fxLayout-column mat-icon {
  transform: translateY(5px);
}

mat-list {
  height: 100%;
  padding: 0;
}
mat-list * {
  text-align: right;
  margin: 0;
  padding: 0;
}
mat-list .cv-button {
  background-color: var(--dark-blue);
  color: var(--text-color);
}
mat-list .cv-button mat-icon {
  color: var(--text-color);
}
mat-list mat-list-item div {
  text-align: center;
  width: 100%;
}
mat-list .mat-list-item-content {
  padding: 0;
  margin: 0;
}
mat-list mat-icon {
  margin: 0 0.5rem;
  color: var(--text-color);
}
mat-list span {
  color: var(--text-color);
}
mat-list button {
  padding-left: 2rem;
}
mat-list .person_phone {
  padding-left: 2rem;
}

mat-toolbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: var(--background);
  border-bottom: 2px solid var(--mid-gray);
  color: var(--text-color);
}
mat-toolbar .container {
  width: 92%;
  height: 100%;
  margin: 0 auto;
}
mat-toolbar .container a {
  height: 80%;
}
mat-toolbar .container a img {
  height: 100%;
}
mat-toolbar .container .user-menu-button {
  padding-right: 15px;
}
mat-toolbar .container .user-menu-button mat-icon {
  margin: 0 0.5rem;
}
mat-toolbar .container .centerButtons mat-icon {
  margin-right: 5px;
  margin-left: 0;
}
mat-toolbar .container .centerButtons .menu-button {
  padding-right: 15px !important;
}
mat-toolbar .container .centerButtons button {
  border: 0 solid;
  margin: 0 5px;
}
mat-toolbar .container .rightButtons button {
  margin: 0px;
}
mat-toolbar .container .rightButtons mat-icon {
  margin-right: 0.5rem;
}

button.mat-menu-item {
  width: 100%;
}

@media only screen and (max-width: 1279px) {
  .fxHide-lt-lg {
    display: none;
  }
}
@media only screen and (min-width: 1280px) {
  .fxhide-gt-md {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/navbar/navbar.component.scss"],"names":[],"mappings":"AACA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,WAAA;AAAF;AACE;EACE,6BAAA;EACA,UAAA;AACJ;;AAGA;EACE,0BAAA;AAAF;;AAIA;EACE,YAAA;EACA,UAAA;AADF;AAGE;EACE,iBAAA;EACA,SAAA;EACA,UAAA;AADJ;AAIE;EACE,kCAAA;EACA,wBAAA;AAFJ;AAII;EACE,wBAAA;AAFN;AAOI;EACE,kBAAA;EACA,WAAA;AALN;AASE;EACE,UAAA;EACA,SAAA;AAPJ;AAWE;EACE,gBAAA;EACA,wBAAA;AATJ;AAYE;EACE,wBAAA;AAVJ;AAaE;EACE,kBAAA;AAXJ;AAaE;EACE,kBAAA;AAXJ;;AAeA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,mCAAA;EACA,wCAAA;EACA,wBAAA;AAZF;AAcE;EACE,UAAA;EACA,YAAA;EACA,cAAA;AAZJ;AAcI;EACE,WAAA;AAZN;AAcM;EACE,YAAA;AAZR;AAgBI;EACE,mBAAA;AAdN;AAgBM;EACE,gBAAA;AAdR;AAmBM;EACE,iBAAA;EACA,cAAA;AAjBR;AAoBM;EACE,8BAAA;AAlBR;AAqBM;EACE,eAAA;EACA,aAAA;AAnBR;AAyBM;EACE,WAAA;AAvBR;AA0BM;EACE,oBAAA;AAxBR;;AA8BA;EACE,WAAA;AA3BF;;AA+BA;EACE;IACE,aAAA;EA5BF;AACF;AAgCA;EACE;IACE,aAAA;EA9BF;AACF","sourcesContent":["// TODO: ng-deep is deprecated, I can't find a better solution\r\n:host ::ng-deep .mat-list-item-content {\r\n  padding: 0 !important;\r\n}\r\n\r\n.button-blue {\r\n  border-radius: 1.5rem;\r\n}\r\n\r\nmat-sidenav-container {\r\n  z-index: 10;\r\n  & > * {\r\n    background: var(--background);\r\n    width: 50%;\r\n  }\r\n}\r\n\r\n.fxLayout-column mat-icon{\r\n  transform: translateY(5px);\r\n}\r\n\r\n\r\nmat-list {\r\n  height: 100%;\r\n  padding: 0;\r\n\r\n  * {\r\n    text-align: right;\r\n    margin: 0;\r\n    padding: 0;\r\n  }\r\n\r\n  .cv-button {\r\n    background-color: var(--dark-blue);\r\n    color: var(--text-color);\r\n\r\n    mat-icon {\r\n      color: var(--text-color);\r\n    }\r\n  }\r\n\r\n  mat-list-item {\r\n    div {\r\n      text-align: center;\r\n      width: 100%;\r\n    }\r\n  }\r\n\r\n  .mat-list-item-content {\r\n    padding: 0;\r\n    margin: 0;\r\n\r\n  }\r\n\r\n  mat-icon {\r\n    margin: 0 0.5rem;\r\n    color: var(--text-color);\r\n  }\r\n  \r\n  span {\r\n    color: var(--text-color);\r\n  }\r\n\r\n  button {\r\n    padding-left: 2rem;\r\n  }\r\n  .person_phone{\r\n    padding-left: 2rem;\r\n  }\r\n}\r\n\r\nmat-toolbar {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  background-color: var(--background);\r\n  border-bottom: 2px solid var(--mid-gray);\r\n  color: var(--text-color);\r\n\r\n  .container {\r\n    width: 92%;\r\n    height: 100%;\r\n    margin: 0 auto;\r\n\r\n    a {\r\n      height: 80%;\r\n\r\n      img {\r\n        height: 100%;\r\n      }\r\n    }\r\n\r\n    .user-menu-button {\r\n      padding-right: 15px;\r\n\r\n      mat-icon {\r\n        margin: 0 0.5rem;\r\n      }\r\n    }\r\n    \r\n    .centerButtons {\r\n      mat-icon {\r\n        margin-right: 5px;\r\n        margin-left: 0;\r\n      }\r\n\r\n      .menu-button {\r\n        padding-right: 15px !important;\r\n      }\r\n\r\n      button {\r\n        border: 0 solid;\r\n        margin: 0 5px;\r\n      }\r\n    }\r\n\r\n    .rightButtons {\r\n\r\n      button {\r\n        margin: 0px;\r\n      }\r\n\r\n      mat-icon {\r\n        margin-right: 0.5rem;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\nbutton.mat-menu-item{\r\n  width: 100%;\r\n}\r\n\r\n//  Media query za site uredi pomali od 1280px (xs, sm i md uredi)\r\n@media only screen and (max-width: 1279px) {\r\n  .fxHide-lt-lg{\r\n    display: none;\r\n  }\r\n}\r\n\r\n//  Media query za site uredi pogolemi od 1280px (lg i xl uredi)\r\n@media only screen and (min-width: 1280px) {\r\n  .fxhide-gt-md{\r\n    display: none;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
